import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const StaggerContainerStyled = styled.div`
  opacity: 0;
  animation: ${fadeIn} 0.2s ease-out forwards;
  will-change: opacity;
`;

export const StaggerContainer = ({ children, ...props }) => {
  return (
    <StaggerContainerStyled {...props}>
      {children}
    </StaggerContainerStyled>
  );
};

// Does NOT animate.
// Clicks always land here.
const StaggerItemWrapper = styled.div`
  position: relative;
  pointer-events: auto;
`;

// Animates, but NEVER receives pointer events.
// Safari-safe.
const StaggerAnimShell = styled.div`
  opacity: 0;
  transform: translateY(12px) scale(0.97);
  animation: ${fadeUp} 0.38s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  animation-delay: ${({ $delay }) => $delay * 0.06}s;

  /* CRITICAL: disable hit testing on the animated layer */
  pointer-events: none;

  will-change: transform, opacity;
`;

export const StaggerItem = ({ children, $delay = 0, ...props }) => {
  return (
    <StaggerItemWrapper {...props}>
      <StaggerAnimShell $delay={$delay}>
        {/* Clickable content */}
        <div style={{ pointerEvents: 'auto' }}>{children}</div>
      </StaggerAnimShell>
    </StaggerItemWrapper>
  );
};
